import { render, staticRenderFns } from "./BulmaMessage.vue?vue&type=template&id=6b96448f&scoped=true"
import script from "./BulmaMessage.vue?vue&type=script&lang=js"
export * from "./BulmaMessage.vue?vue&type=script&lang=js"
import style0 from "./BulmaMessage.vue?vue&type=style&index=0&id=6b96448f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b96448f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b96448f')) {
      api.createRecord('6b96448f', component.options)
    } else {
      api.reload('6b96448f', component.options)
    }
    module.hot.accept("./BulmaMessage.vue?vue&type=template&id=6b96448f&scoped=true", function () {
      api.rerender('6b96448f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaMessage/BulmaMessage.vue"
export default component.exports